import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { FadeUp } from "@/components/Reveal";
import { api, setToken, formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/auth/login", { email, password });
      setToken(res.data.token);
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiError(err, "Login failed."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto max-w-md px-4 pb-24 pt-40 sm:px-6" data-testid="admin-login-page">
      <FadeUp>
        <div className="rounded-3xl border border-linen bg-white/70 p-8 shadow-xl shadow-olive/5 sm:p-10">
          <div className="flex items-center gap-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-olive">
              <Lock className="h-5 w-5 text-cream" />
            </div>
            <div>
              <h1 className="font-serif text-2xl text-olive">Admin Login</h1>
              <p className="text-xs text-sage">Fresh Start Furnishings team only</p>
            </div>
          </div>
          <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
            <label className="block">
              <span className="mb-1.5 block text-sm font-semibold text-olive">Email</span>
              <input data-testid="admin-email-input" type="email" required className="input-field" value={email} onChange={(e) => setEmail(e.target.value)} />
            </label>
            <label className="block">
              <span className="mb-1.5 block text-sm font-semibold text-olive">Password</span>
              <input data-testid="admin-password-input" type="password" required className="input-field" value={password} onChange={(e) => setPassword(e.target.value)} />
            </label>
            <button type="submit" data-testid="admin-login-button" disabled={loading} className="btn-primary w-full !py-4 disabled:opacity-60">
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : null}
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
      </FadeUp>
    </div>
  );
}
